export default [
  {
    text: 'Attempt',
    value: '_id',
    label: 'time',
    type: 'scatter',
    x: 'datetime',
  },
  {
    text: 'Day',
    value: 'day',
    iteratee: v => (new Date(v.time)).toISOString().substr(0, 10),
    label: 'label',
    type: 'scatter',
    x: 'datetime',
  },
  {
    text: 'Duration',
    value: 'duration',
    label: 'durations.0',
    type: 'scatter',
    x: 'numeric',
  },
  {
    text: 'Flag',
    value: 'flagId',
    flatten: 'flagIds',
    populated: [{ field: 'flags', label: 'name' }],
    label: 'flags.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Grade',
    value: 'grade',
    label: 'grades.0',
    type: 'scatter',
    x: 'numeric',
  },
  {
    text: 'Location',
    value: 'locId',
    label: 'locations.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Procedure',
    value: 'proId',
    flatten: 'proIds',
    populated: [{ field: 'procedures', label: 'text' }],
    label: 'procedures.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Step',
    value: 'stepId',
    flatten: 'stepIds',
    populated: [{ field: 'steps', label: 'text' }, { field: 'grades', id: 'stepId' }],
    label: 'steps.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Student',
    value: 'studentId',
    label: 'students.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Supervisor',
    value: 'supervisorId',
    label: 'supervisors.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Tooth',
    value: 'tooth',
    flatten: 'teeth',
    label: 'teeth.0',
    type: 'bar',
    x: 'category',
  },
  {
    text: 'Unit',
    value: 'unitId',
    label: 'units.0',
    type: 'bar',
    x: 'category',
  },
];
